export default "__VITE_ASSET__inXM7Nf9__"